"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceApi = void 0;
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class MaintenanceApi extends runtime.BaseAPI {
    /**
     * Get the maintenance
     * Get maintenance
     */
    getMaintenanceRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/maintenance`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiGetMaintenanceResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the maintenance
     * Get maintenance
     */
    getMaintenance(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMaintenanceRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the next scheduled maintenance that hasn\'t started yet
     * Get next scheduled maintenance
     */
    getScheduledMaintenanceRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/maintenance/scheduled`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiGetMaintenanceResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the next scheduled maintenance that hasn\'t started yet
     * Get next scheduled maintenance
     */
    getScheduledMaintenance(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScheduledMaintenanceRaw(initOverrides);
            switch (response.raw.status) {
                case 200:
                    return yield response.value();
                case 204:
                    return null;
                default:
                    return yield response.value();
            }
        });
    }
    /**
     * Post the maintenance end
     * Post maintenance end
     */
    postMaintenanceEndRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/maintenance/end`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostMaintenanceEndResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Post the maintenance end
     * Post maintenance end
     */
    postMaintenanceEnd(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postMaintenanceEndRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Post the maintenance start
     * Post maintenance start
     */
    postMaintenanceStartRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostMaintenanceStartRequest'] == null) {
                throw new runtime.RequiredError('apiPostMaintenanceStartRequest', 'Required parameter "apiPostMaintenanceStartRequest" was null or undefined when calling postMaintenanceStart().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/maintenance/start`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostMaintenanceStartRequestToJSON)(requestParameters['apiPostMaintenanceStartRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostMaintenanceStartResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Post the maintenance start
     * Post maintenance start
     */
    postMaintenanceStart(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postMaintenanceStartRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.MaintenanceApi = MaintenanceApi;
